"use client";

import LandingPage from "@/app/versioning/page/LandingPage";

export default LandingPage;
